import { useState, type MouseEvent } from 'react';
import { Card, Col, Image, Row } from 'react-bootstrap';
import CircularPieCharts from './CircularPieCharts';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Flex from '@/components/common/Flex';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import useDomain from '@/hooks/useDomain';
import type {
  AnalysisOverviewResponse,
  LighthouseCategory
} from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = {
  analysisData?: AnalysisOverviewResponse | null;
};

const SpeedOverview = ({ analysisData }: Props) => {
  const { domain, domain_slug } = useDomain();
  const { slug } = useParams<{ slug?: string }>();
  const [srcImage, setSrcImage] = useState<string>('');

  const handleImageClick = (event: MouseEvent<HTMLImageElement>) => {
    event.preventDefault();
    setSrcImage(event.currentTarget.getAttribute('src') || '');
  };

  const categories = analysisData?.data?.details?.categories || {};
  const categoriesArray = Object.entries(categories) as [
    string,
    LighthouseCategory
  ][];

  return (
    <>
      <Card className="my-3">
        <Card.Body>
          <Flex className="align-items-center flex-column flex-lg-row justify-content-center gap-3">
            <Row className="justify-content-center align-items-center g-4">
              {categoriesArray.length > 0 ? (
                categoriesArray.map(([title, value]) => (
                  <Col key={title} xs="auto">
                    <Link
                      className="d-flex flex-column gap-1 align-items-center"
                      to={`/analysis/speed/${slug}/${domain_slug}/${domain}#${value?.id}`}
                    >
                      <CircularPieCharts data={value} />
                      <div className="fw-bold text-center fs-0">
                        {value?.title}
                      </div>
                    </Link>
                  </Col>
                ))
              ) : (
                <Col xs={12} className="text-center text-muted">
                  <p>داده‌های دسته‌بندی در دسترس نیست</p>
                </Col>
              )}
            </Row>
            {srcImage && (
              <Lightbox
                mainSrc={srcImage}
                onCloseRequest={() => setSrcImage('')}
                reactModalStyle={{ overlay: { zIndex: 999999 } }}
                onImageLoad={() => {
                  window.dispatchEvent(new Event('resize'));
                }}
              />
            )}
            <Image
              onClick={e => handleImageClick(e)}
              src={
                analysisData?.data?.details?.audits?.['final-screenshot']
                  ?.details?.data
              }
              thumbnail
              className="border cursor-pointer"
              style={{
                maxWidth: '211px',
                maxHeight: '169px'
              }}
            />
          </Flex>
        </Card.Body>
      </Card>
    </>
  );
};

export default SpeedOverview;
